export default __webpack_public_path__ + "static/media/wind.74ec1301.svg";